<div id="port-airport"></div>
<app-admin-dashboard>
  <div class="card">
    <p-breadcrumb
      class="w-full breadcrumb-style"
      [home]="breadcrumbHome"/>

    <div class="header-card pt-0">
      <div class="w-12 container-title">
        <h1 class="text-xl font-medium text-800 m-0">
          {{'CountriesPage.PageTitle' | translate}}
        </h1>
      </div>
    </div>

    <div class="body-card mt-3">
      <form [formGroup]="formGroup">
        <div class="flex flex-wrap flex-column justify-content-center align-items-center">
          <div class="w-full md:w-5 p-fluid formgrid grid">

            <div class="field col-12 xl:col-6">
              <label for="name">
                {{'CountriesPage.NameFieldLabel' | translate }}
                <span class="mandatory-field">*</span>
              </label>
              <input
                id="name"
                formControlName="name"
                type="text"
                maxlength="120"
                required
                pInputText
                placeholder="{{'CountriesPage.NameFieldPlaceholder' | translate }}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['name'].invalid" class="p-error">{{getErrorMessage('name')}}</small>
            </div>

            <div class="field col-12 xl:col-6">
              <label for="namees">
                {{'CountriesPage.NameESFieldLabel' | translate }}
                <span class="mandatory-field">*</span>
              </label>
              <input
                id="name"
                formControlName="namees"
                type="text"
                maxlength="120"
                required
                pInputText
                placeholder="{{'CountriesPage.NameESFieldPlaceholder' | translate }}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['namees'].invalid" class="p-error">{{getErrorMessage('namees')}}</small>
            </div>

            <div class="field col-12 xl:col-6" style="margin-bottom: 20px;">
              <label for="code">
                {{'CountriesPage.LocodeFieldLabel' | translate }}
                <span class="mandatory-field">*</span>
              </label>
              <input
                id="code"
                formControlName="code"
                type="text"
                maxlength="50"
                required
                pInputText
                placeholder="{{'CountriesPage.LocodeFieldPlaceholder' | translate }}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['code'].invalid" class="p-error">{{getErrorMessage('code')}}</small>
            </div>

            <div class="field col-12" style="margin-bottom: 20px;">
              <div class="w-full">
                <p-button
                  (onClick)="submitForm()"
                  [loading]="loading"
                  label="{{'CountriesPage.CreateButton' | translate}}"
                  styleClass="p-button-primary"
                  class="custom-text-button"/>
              </div>
            </div>
          </div>

        </div>
      </form>

      <div class="mt-4">
          <p-table
            #tableCountries
            [value]="countries"
            [paginator]="true"
            class="custom-table"
            [lazy]="true"
            (onLazyLoad)="getCountriesPaged($event)"
            [rows]="pageSize"
            [totalRecords]="totalCount"
            [loading]="loading"
            class="custom-table bg-header mt-4"
            >
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <div class="flex justify-content-center align-items-center pl-space-table">
                            {{'CountriesPage.IdColumn' | translate}}
                        </div>
                    </th>
                    <th>
                        <div class="flex align-items-center">
                            {{'CountriesPage.NameFieldLabel' | translate}}
                        </div>
                    </th>
                    <th>
                        <div class="flex align-items-center">
                            {{'CountriesPage.NameESFieldLabel' | translate}}
                        </div>
                    </th>
                    <th>
                        <div class="flex align-items-center">
                            {{'CountriesPage.LocodeFieldLabel' | translate}}
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-country>
                <tr>
                    <td>
                        <div class="flex justify-content-center align-items-center pl-space-table">
                            <span>{{country.id}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="flex align-items-center">
                            <span>{{country.name}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="flex align-items-center">
                            <span>{{country.nameEs}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="flex align-items-center">
                            <span>{{country.code}}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
  </div>
</app-admin-dashboard>
